export default function (state, value) {
  state.loading = false;
  state.article = [];
  state.video = [];
  value.forEach(i => {
    if (i.PageLink.match(/#/g) && i.IsOn) {
      i.path = i.PageLink.replace('spa/#', '');
      i.path = i.path.replace('#', '');
      if (i.Type === 'Article') {
        state.article.push(i);
      }
      if (i.Type === 'Video') {
        state.video.push(i);
      }
    }
    if (i.PageLink === "admin/") {
      i.path = '/';
      if (i.Type === 'Article') state.article.push(i);
      if (i.Type === 'Video') state.video.push(i);
    }
  })
}
